import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  finalize,
  map,
  Observable,
  of,
  shareReplay,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { EpisodeOfCareService } from './episodeOfCare.service';
import { PatientService } from './patient.service';
import { IQuestionnaire } from '../interfaces/Questionnaire/IQuestionnaire';
import {
  IQuestionnaireActor,
  IQuestionnaireDetailed,
  IQuestionnaireScoreRange,
} from '../interfaces/Questionnaire/IQuestionnaireDetailed';
import { IAddQuestionnaireAnswers } from '../interfaces/Questionnaire/IAddQuestionnaireAnswers';
import { QuestionnaireHistoryItem } from '../interfaces/Questionnaire/IQuestionnaireHistory';
import {
  QuestionnaireOverviewQueryOptions,
  QuestionnaireOverviewResponse,
  QuestionnaireOverviewTemplate,
} from '../interfaces/Questionnaire/IQuestionnaireOverview';

@Injectable({
  providedIn: 'root',
})
export class DynamicQuestionnaireService {
  private readonly questionnaireOverviewCache = new Map<
    string,
    Observable<QuestionnaireOverviewResponse>
  >();
  private outpatientJson = {
    title: 'ÎšÎ¿Î¹Î½Ï‰Î½Î¹ÎºÏŒ Î™ÏƒÏ„Î¿ÏÎ¹ÎºÏŒ',
    logoPosition: 'right',
    pages: [
      {
        name: 'page1',
        elements: [
          {
            type: 'comment',
            name: 'question40',
            title:
              'Î”Î¹Î±Î¸Î­Ï„ÎµÎ¹ Î® Î­Ï‡ÎµÎ¹ Ï€ÏÏŒÏƒÎ²Î±ÏƒÎ· ÏƒÎµ Î·/Ï… Î® tablet',
          },
          {
            type: 'comment',
            name: 'question41',
            title:
              'Î”Î¹Î±Î¸Î­Ï„ÎµÎ¹ Î® Î­Ï‡ÎµÎ¹ Ï€ÏÏŒÏƒÎ²Î±ÏƒÎ· ÏƒÎµ Î´Î¹Î±Î´Î¯ÎºÏ„Ï…Î¿',
          },
        ],
        title: 'Î”Î·Î¼Î¿Î³ÏÎ±Ï†Î¹ÎºÎ¬ Î£Ï„Î¿Î¹Ï‡ÎµÎ¯Î±',
      },
      {
        name: 'page2',
        elements: [
          {
            type: 'text',
            name: 'question1',
            title: 'ÎŸÎ½Î¿Î¼Î±Ï„ÎµÏ€ÏŽÎ½Ï…Î¼Î¿ Î ÏÎ¿ÏƒÏ‰Ï€Î¹ÎºÎ¿Ï Î™Î±Ï„ÏÎ¿Ï',
          },
          {
            type: 'text',
            name: 'question2',
            title:
              'Î¤Î·Î»Î­Ï†Ï‰Î½Î¿ Î•Ï€Î¹ÎºÎ¿Î¹Î½Ï‰Î½Î¯Î±Ï‚ Î ÏÎ¿ÏƒÏ‰Ï€Î¹ÎºÎ¿Ï Î™Î±Ï„ÏÎ¿Ï',
          },
          {
            type: 'comment',
            name: 'question4',
            title:
              'Î Î±ÏÎ±ÎºÎ¿Î»Î¿Ï…Î¸ÎµÎ¯Ï„Îµ Î±Ï€ÏŒ Î¹Î±Ï„ÏÏŒ Î´Î¹Î±Ï†Î¿ÏÎµÏ„Î¹ÎºÎ®Ï‚ ÎµÎ¹Î´Î¹ÎºÏŒÏ„Î·Ï„Î±Ï‚ (ÎµÎ¹Î´Î¹ÎºÏŒÏ„Î·Ï„Î±, Î¿Î½Î¿Î¼Î±Ï„ÎµÏ€ÏŽÎ½Ï…Î¼Î¿\r\nÎºÎ±Î¹ ÏƒÏ„Î¿Î¹Ï‡ÎµÎ¯Î± ÎµÏ€Î¹ÎºÎ¿Î¹Î½Ï‰Î½Î¯Î±Ï‚);',
          },
          {
            type: 'radiogroup',
            name: 'question7',
            title: 'ÎšÎ¹Î½Î·Ï„Î¹ÎºÎ® Î»ÎµÎ¹Ï„Î¿Ï…ÏÎ³Î¹ÎºÏŒÏ„Î·Ï„Î±:',
            choices: [
              {
                value: 'Item 1',
                text: 'ÎšÎ»Î¹Î½Î®ÏÎ·Ï‚',
              },
              {
                value: 'Item 2',
                text: 'ÎšÎ¹Î½ÎµÎ¯Ï„Î±Î¹ Î¼Îµ Î±Î½Î±Ï€Î·ÏÎ¹ÎºÏŒ Î±Î¼Î±Î¾Î¯Î´Î¹Î¿',
              },
              {
                value: 'Item 3',
                text: 'ÎšÎ¹Î½ÎµÎ¯Ï„Î±Î¹ Î¼Îµ Ï…Ï€Î¿Î²Î¿Î®Î¸Î·ÏƒÎ· (Î  Î® Î¼Ï€Î±ÏƒÏ„Î¿ÏÎ½Î¹)',
              },
              {
                value: 'Item 4',
                text: 'ÎšÎ¹Î½ÎµÎ¯Ï„Î±Î¹ ÎºÎ±Î½Î¿Î½Î¹ÎºÎ¬',
              },
            ],
            showOtherItem: true,
            otherText: 'Î†Î»Î»Î¿:',
          },
        ],
        title:
          'Î Î»Î·ÏÎ¿Ï†Î¿ÏÎ¯ÎµÏ‚ Î³Î¹Î± Ï„Î¿ ÎÎ¿ÏƒÎ·Î»ÎµÏ…Ï„Î¹ÎºÏŒ Î ÏÎ¿ÏƒÏ‰Ï€Î¹ÎºÏŒ',
      },
      {
        name: 'page3',
        elements: [
          {
            type: 'comment',
            name: 'question9',
            title:
              'ÎšÎ¿Î¹Î½Ï‰Î½Î¹ÎºÎ¿ â€“ Î¿Î¹ÎºÎ¿Î½Î¿Î¼Î¹ÎºÎ­Ï‚ ÏƒÏ…Î½Î¸Î®ÎºÎµÏ‚ Ï„Î·Ï‚ Î¿Î¹ÎºÎ¿Î³Î­Î½ÎµÎ¹Î±Ï‚',
          },
          {
            type: 'comment',
            name: 'question10',
            title:
              'Î£Ï‡Î­ÏƒÎµÎ¹Ï‚ Î¼ÎµÏ„Î±Î¾Ï Ï„Ï‰Î½ Î¼ÎµÎ»ÏŽÎ½ ÎºÎ±Î¹ ÎµÎ¯Î´Î¿Ï‚ ÎµÏ€Î±Ï†Î®Ï‚ Ï€Î¿Ï… Î´Î¹Î±Ï„Î·ÏÎµÎ¯ Î¼Îµ Ï„Î·Î½ Î¿Î¹ÎºÎ¿Î³Î­Î½ÎµÎ¹Î±',
          },
        ],
        title: 'ÎŸÎ¹ÎºÎ¿Î³ÎµÎ½ÎµÎ¹Î±ÎºÏŒ Î™ÏƒÏ„Î¿ÏÎ¹ÎºÏŒ',
      },
      {
        name: 'page4',
        elements: [
          {
            type: 'comment',
            name: 'question11',
            title: 'Î›ÏŒÎ³Î¿Ï‚ Ï€Î±ÏÎ±Ï€Î¿Î¼Ï€Î®Ï‚;',
          },
          {
            type: 'comment',
            name: 'question12',
            title:
              'Î Î¿Î¹Î¿Ï‚ Î­Ï‡ÎµÎ¹ Ï„Î·Î½ ÎµÏ…Î¸ÏÎ½Î· Ï„Î·Ï‚ Ï†ÏÎ¿Î½Ï„Î¯Î´Î±Ï‚ Ï„Î¿Ï… ÎµÎ¾Ï…Ï€Î·ÏÎµÏ„Î¿ÏÎ¼ÎµÎ½Î¿Ï…;',
          },
          {
            type: 'comment',
            name: 'question13',
            title: 'Î Î¿Î¹Î¿Ï‚ Î­ÎºÎ±Î½Îµ Ï„Î·Î½ Ï€Î±ÏÎ±Ï€Î¿Î¼Ï€Î®;',
          },
        ],
        title:
          'Î•Î¹ÎºÏŒÎ½Î± Ï„Î¿Ï… Î±ÏƒÎ¸ÎµÎ½Î® ÏƒÏ„Î¿ Ï€Î±ÏÏŒÎ½/Î Î±ÏÎ¿Ï…ÏƒÎ¹Î±Î¶ÏŒÎ¼ÎµÎ½Î¿ Ï€ÏÏŒÎ²Î»Î·Î¼Î±',
      },
      {
        name: 'page6',
        elements: [
          {
            type: 'comment',
            name: 'question15',
            title: 'Î§ÏÏŒÎ½Î¹ÎµÏ‚ Î Î±Î¸Î®ÏƒÎµÎ¹Ï‚ / ÎœÎ¿Î»ÏÎ½ÏƒÎµÎ¹Ï‚',
          },
          {
            type: 'comment',
            name: 'question16',
            title: 'Î”Î¹Î±Ï„Î±ÏÎ±Ï‡Î­Ï‚ Î”Î¹Î±Ï„ÏÎ¿Ï†Î®Ï‚',
          },
          {
            type: 'comment',
            name: 'question17',
            title: 'Î£Ï‰Î¼Î±Ï„Î¹ÎºÎ¬ Î¤ÏÎ±ÏÎ¼Î±Ï„Î±',
          },
          {
            type: 'comment',
            name: 'question18',
            title:
              'Î Î±ÏÎ¬Î³Î¿Î½Ï„ÎµÏ‚ ÎºÎ¹Î½Î´ÏÎ½Î¿Ï… Î»ÏŒÎ³Ï‰ Î¿Î¹ÎºÎ¿Î³ÎµÎ½ÎµÎ¹Î±ÎºÎ¿Ï Î¹Î±Ï„ÏÎ¹ÎºÎ¿Ï Î¹ÏƒÏ„Î¿ÏÎ¹ÎºÎ¿Ï',
          },
          {
            type: 'comment',
            name: 'question19',
            title: 'Î¦Î±ÏÎ¼Î±ÎºÎµÏ…Ï„Î¹ÎºÎ® Î‘Î³Ï‰Î³Î®',
          },
          {
            type: 'comment',
            name: 'question3',
            title: 'Î†Î»Î»Î¿',
          },
        ],
        title: 'Î™Î±Ï„ÏÎ¹ÎºÏŒ Î™ÏƒÏ„Î¿ÏÎ¹ÎºÏŒ',
      },
      {
        name: 'page7',
        elements: [
          {
            type: 'comment',
            name: 'question20',
            title:
              'Î¨Ï…Ï‡Î¹ÎºÎ® ÎºÎ±Ï„Î¬ÏƒÏ„Î±ÏƒÎ·: ÎµÎ¼Ï†Î¬Î½Î¹ÏƒÎ·, ÏƒÏ„Î¬ÏƒÎ·, ÏƒÏ…Î¼Ï€ÎµÏÎ¹Ï†Î¿ÏÎ¬ ÎºÎ±Î¹ ÎµÏ€ÎµÎ¾ÎµÏÎ³Î±ÏƒÎ¯Î± ÏƒÎºÎ­ÏˆÎ·Ï‚',
          },
          {
            type: 'comment',
            name: 'question21',
            title: 'ÎšÎ±Ï„Î¬Î¸Î»Î¹ÏˆÎ·',
          },
          {
            type: 'boolean',
            name: 'question22',
            title:
              'ÎÎ¹ÏŽÎ¸ÎµÎ¹ Î»Ï…Ï€Î·Î¼Î­Î½Î¿Ï‚/ÏƒÏ„ÎµÎ½Î±Ï‡Ï‰ÏÎ·Î¼Î­Î½Î¿Ï‚;',
            labelTrue: 'ÎÎ±Î¯',
            labelFalse: 'ÎŒÏ‡Î¹',
          },
          {
            type: 'boolean',
            name: 'question23',
            title: 'ÎÎ¹ÏŽÎ¸ÎµÎ¹ Î±Î³Ï‡Ï‰Î¼Î­Î½Î¿Ï‚;',
            labelTrue: 'ÎÎ±Î¯',
            labelFalse: 'ÎŒÏ‡Î¹',
          },
          {
            type: 'boolean',
            name: 'question24',
            title: 'Î”Î¹Î±Ï„Î±ÏÎ±Ï‡Î­Ï‚ ÏÏ€Î½Î¿Ï…/ÎµÏ†Î¹Î¬Î»Ï„ÎµÏ‚;',
            labelTrue: 'ÎÎ±Î¯',
            labelFalse: 'ÎŒÏ‡Î¹',
          },
          {
            type: 'comment',
            name: 'question25',
            title:
              'ÎˆÏ‡ÎµÎ¹ Ï€ÏÎ¿Î²Î»Î®Î¼Î±Ï„Î± ÏƒÏ„Î¿Î½ ÏÏ€Î½Î¿ Ï„Î¿Ï…; (ÏŒÎ½ÎµÎ¹ÏÎ±/ÎµÏ†Î¹Î¬Î»Ï„ÎµÏ‚, Î´Ï…ÏƒÎºÎ¿Î»ÎµÏÎµÏ„Îµ Î½Î± ÎºÎ¿Î¹Î¼Î·Î¸ÎµÎ¯,\r\nÎ¾Ï…Ï€Î½Î¬ Î¼Î­ÏƒÎ± ÏƒÏ„Î· Î½ÏÏ‡Ï„Î±;)',
          },
          {
            type: 'boolean',
            name: 'question26',
            title: 'ÎœÎµÏ„Î±Ï„ÏÎ±Ï…Î¼Î±Ï„Î¹ÎºÏŒ Î£Ï„ÏÎµÏ‚',
            labelTrue: 'ÎÎ±Î¯',
            labelFalse: 'ÎŒÏ‡Î¹',
          },
          {
            type: 'comment',
            name: 'question27',
            title:
              'Î‘Î½Î±Î²Î¹ÏŽÎ½ÎµÎ¹ (Ï€.Ï‡ ÎµÏ†Î¹Î¬Î»Ï„ÎµÏ‚, flashbacks) Î­Î½Î± Î® Ï€ÎµÏÎ¹ÏƒÏƒÏŒÏ„ÎµÏÎ± Ï„ÏÎ±Ï…Î¼Î±Ï„Î¹ÎºÎ¬ Î³ÎµÎ³Î¿Î½ÏŒÏ„Î±;',
          },
          {
            type: 'comment',
            name: 'question28',
            title:
              'ÎÎ¹ÏŽÎ¸ÎµÎ¹ ÏŒÏ„Î¹ Î´ÎµÎ½ Î¼Ï€Î¿ÏÎµÎ¯ Î½Î± Î¸Ï…Î¼Î·Î¸ÎµÎ¯ ÏƒÎ·Î¼Î±Î½Ï„Î¹ÎºÎ¬ ÎºÎ¿Î¼Î¼Î¬Ï„Î¹Î± Ï„Î¿Ï…/Ï„Ï‰Î½ Ï„ÏÎ±Ï…Î¼Î±Ï„Î¹ÎºÎ¿Ï/Ï‰Î½\r\nÎ³ÎµÎ³Î¿Î½ÏŒÏ„Î¿Ï‚/Ï„Ï‰Î½;',
          },
          {
            type: 'comment',
            name: 'question29',
            title: 'ÎžÎµÏ‡Î½Î¬ ÎµÏÎºÎ¿Î»Î±;',
          },
          {
            type: 'boolean',
            name: 'question30',
            title: 'Î‘Ï…Ï„Î¿ÎºÏ„Î¿Î½Î¹ÎºÏŒÏ„Î·Ï„Î±',
            labelTrue: 'ÎÎ±Î¯',
            labelFalse: 'ÎŒÏ‡Î¹',
          },
          {
            type: 'boolean',
            name: 'question31',
            title:
              'Î£ÎºÎ­Ï†Î¸Î·ÎºÎµ Ï€Î¿Ï„Î­ Î½Î± ÎºÎ¬Î½ÎµÎ¹ ÎºÎ±ÎºÏŒ ÏƒÏ„Î¿Î½ ÎµÎ±Ï…Ï„ÏŒ Ï„Î¿Ï…;',
            labelTrue: 'ÎÎ±Î¯',
            labelFalse: 'ÎŒÏ‡Î¹',
          },
          {
            type: 'boolean',
            name: 'question32',
            title:
              'ÎšÎ¬Î½ÎµÎ¹ ÏƒÏ…Ï‡Î½Î­Ï‚ ÏƒÎºÎ­ÏˆÎµÎ¹Ï‚ Î³Î¹Î± Ï„Î¿ Î¸Î¬Î½Î±Ï„Î¿;',
            labelTrue: 'ÎÎ±Î¯',
            labelFalse: 'ÎŒÏ‡Î¹',
          },
          {
            type: 'boolean',
            name: 'question33',
            title: 'ÎÎ¹ÏŽÎ¸ÎµÎ¹ ÏŒÏ„Î¹ Î´ÎµÎ½ Î­Ï‡ÎµÎ¹ Î½ÏŒÎ·Î¼Î± Î½Î± Î¶ÎµÎ¹;',
            labelTrue: 'ÎÎ±Î¯',
            labelFalse: 'ÎŒÏ‡Î¹',
          },
        ],
        title: 'Î¨Ï…Ï‡Î¿Î»Î¿Î³Î¹ÎºÏŒ Î™ÏƒÏ„Î¿ÏÎ¹ÎºÏŒ / Î‘Î¾Î¹Î¿Î»ÏŒÎ³Î·ÏƒÎ·',
      },
      {
        name: 'page8',
        elements: [
          {
            type: 'comment',
            name: 'question35',
            title:
              'Î Î¿Î¹ÎµÏ‚ ÎµÎ¯Î½Î±Î¹ Î¿Î¹ Î¸ÏÎ·ÏƒÎºÎµÏ…Ï„Î¹ÎºÎ­Ï‚ ÎºÎ±Î¹ Ï€Î¿Î»Î¹Ï„Î¹ÏƒÏ„Î¹ÎºÎ­Ï‚ ÏƒÏ…Î½Î®Î¸ÎµÎ¹ÎµÏ‚ Ï„Î¿Ï…;',
          },
        ],
        title:
          'Î˜ÏÎ·ÏƒÎºÎµÏ…Ï„Î¹ÎºÎ­Ï‚ ÎºÎ±Î¹ Ï€Î¿Î»Î¹Ï„Î¹ÏƒÏ„Î¹ÎºÎ­Ï‚ ÏƒÏ…Î½Î®Î¸ÎµÎ¹ÎµÏ‚',
      },
      {
        name: 'page9',
        elements: [
          {
            type: 'comment',
            name: 'question36',
            title:
              'Î•Î½Î´Î¹Î±Ï†Î­ÏÎ¿Î½Ï„Î±, Î´ÎµÎ¾Î¹ÏŒÏ„Î·Ï„ÎµÏ‚, Ï„Î±Î»Î­Î½Ï„Î±, Ï‡ÏŒÎ¼Ï€Ï…',
          },
        ],
        title: 'Î•Î½Î´Î¹Î±Ï†Î­ÏoÎ½Ï„Î± ÎºÎ±Î¹ Î”ÎµÎ¾Î¹ÏŒÏ„Î·Ï„ÎµÏ‚',
      },
      {
        name: 'page',
        elements: [
          {
            type: 'comment',
            name: 'question37',
            title:
              'Î™ÏƒÏ„Î¿ÏÎ¹ÎºÏŒ Î´Î¹Î±Î¼Î¿Î½Î®Ï‚ ÏƒÎµ Î¬Î»Î»Î· Î•Ï…ÏÏ‰Ï€Î±ÏŠÎºÎ® Ï‡ÏŽÏÎ± (Ï…Ï€ÏŒ Ï€Î¿Î¹Î¿ ÎºÎ±Î¸ÎµÏƒÏ„ÏŽÏ‚)',
          },
          {
            type: 'comment',
            name: 'question38',
            title: 'Î™ÏƒÏ„Î¿ÏÎ¹ÎºÏŒ Î´Î¹ÎºÎ±ÏƒÏ„Î¹ÎºÏŽÎ½ Ï…Ï€Î¿Î¸Î­ÏƒÎµÏ‰Î½',
          },
        ],
        title: 'ÎÎ¿Î¼Î¹ÎºÏŒ Î™ÏƒÏ„Î¿ÏÎ¹ÎºÏŒ',
      },
      {
        name: 'page10',
        elements: [
          {
            type: 'text',
            name: 'question39',
            title: 'Î Î±ÏÎ±ÎºÎ±Î»ÏŽ Ï€ÎµÏÎ¹Î³ÏÎ¬ÏˆÏ„Îµ',
          },
        ],
        title: 'Î†Î»Î»ÎµÏ‚ ÏƒÎ·Î¼Î±Î½Ï„Î¹ÎºÎ­Ï‚ Ï€Î»Î·ÏÎ¿Ï†Î¿ÏÎ¯ÎµÏ‚',
      },
    ],
    showPageNumbers: true,
  };

  private hasUnsavedChanges = new BehaviorSubject<boolean>(false);

  setUnsavedChanges(state: boolean): void {
    this.hasUnsavedChanges.next(state);
  }

  getUnsavedChanges() {
    return this.hasUnsavedChanges.asObservable();
  }

  constructor(
    private http: HttpClient,
    private readonly eocService: EpisodeOfCareService,
    private readonly patientService: PatientService,
  ) {}

  getQuestionnaireData(
    questionnaireTemplateId: number,
  ): Observable<IQuestionnaireDetailed> {
    const patientId = this.patientService.patientIDsignal();
    const visitId = this.resolveVisitId();
    let params = new HttpParams();

    if (visitId !== null) {
      params = params.set('visitId', visitId.toString());
    }

    return this.http
      .get<any>(
        `${environment.BACKEND_URL}Questionnaire/${patientId}/${questionnaireTemplateId}/current`,
        { params },
      )
      .pipe(
        map((response) => this.mapCurrentQuestionnaire(response)),
        switchMap((questionnaire: IQuestionnaireDetailed | null) => {
          if (questionnaire?.questionnaire) {
            return of(questionnaire);
          }

          return this.getBlankQuestionnaire(questionnaireTemplateId);
        }),
      );
  }

  getBlankQuestionnaireData(
    questionnaireTemplateId: number,
  ): Observable<IQuestionnaireDetailed> {
    return this.getBlankQuestionnaire(questionnaireTemplateId);
  }

  getQuestionnaireOverview(
    patientId: string,
    options: QuestionnaireOverviewQueryOptions = {},
  ): Observable<QuestionnaireOverviewResponse> {
    let params = new HttpParams();

    if (options.templateIds?.length) {
      params = params.set('templateIds', options.templateIds.join(','));
    }

    if (options.visitId !== undefined && options.visitId !== null) {
      params = params.set('visitId', options.visitId.toString());
    }

    if (options.episodeCareId !== undefined && options.episodeCareId !== null) {
      params = params.set('episodeCareId', options.episodeCareId.toString());
    }

    if (options.includeDrafts !== undefined) {
      params = params.set('includeDrafts', options.includeDrafts.toString());
    }

    if (options.section) {
      params = params.set('section', options.section);
    }

    const cacheKey = this.getQuestionnaireOverviewCacheKey(patientId, options);
    const forceRefresh = options.forceRefresh === true;

    if (forceRefresh) {
      this.questionnaireOverviewCache.delete(cacheKey);
    }

    const cachedRequest = this.questionnaireOverviewCache.get(cacheKey);

    if (cachedRequest) {
      return cachedRequest;
    }

    const request$ = this.http
      .get<any>(
        `${environment.BACKEND_URL}Questionnaire/${patientId}/overview`,
        {
          params,
        },
      )
      .pipe(
        map((response) => this.normalizeOverviewResponse(response)),
        shareReplay(1),
        finalize(() => {
          this.questionnaireOverviewCache.delete(cacheKey);
        }),
        catchError((error) => {
          this.questionnaireOverviewCache.delete(cacheKey);
          return throwError(() => error);
        }),
      );

    this.questionnaireOverviewCache.set(cacheKey, request$);

    return request$;
  }

  invalidateQuestionnaireOverviewCache(): void {
    this.questionnaireOverviewCache.clear();
  }

  addQuestionnaireAnswers(qaObj: IAddQuestionnaireAnswers) {
    // Visit-scoped questionnaires still use the existing EHR payload.
    if (
      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].includes(
        qaObj.questionnaireTemplateId,
      )
    ) {
      qaObj.visitId = Number(this.eocService.currentVisitId());
      qaObj.patientId = Number(this.patientService.patientIDsignal());
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http
      .post(`${environment.BACKEND_URL}Questionnaire`, qaObj, {
        headers: headers,
      })
      .pipe(tap(() => this.clearQuestionnaireCaches()));
  }

  saveQuestionnaireAnswers(
    questionnaire: IQuestionnaireDetailed | undefined,
    qaObj: IAddQuestionnaireAnswers,
  ) {
    if (questionnaire?.id && questionnaire.isSubmitted === false) {
      return this.updateQuestionnaireAnswers(questionnaire.id, qaObj);
    }

    return this.addQuestionnaireAnswers(qaObj);
  }

  updateQuestionnaireAnswers(
    questionnaireId: number,
    qaObj: IAddQuestionnaireAnswers,
  ) {
    // Visit-scoped questionnaires still use the existing EHR payload.
    if (
      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].includes(
        qaObj.questionnaireTemplateId,
      )
    ) {
      qaObj.visitId = Number(this.eocService.currentVisitId());
      qaObj.patientId = Number(this.patientService.patientIDsignal());
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http
      .put(
        `${environment.BACKEND_URL}Questionnaire/drafts/${questionnaireId}`,
        qaObj,
        {
          headers: headers,
        },
      )
      .pipe(tap(() => this.clearQuestionnaireCaches()));
  }

  deleteQuestionnaireDraft(questionnaireId: number) {
    return this.http
      .delete(`${environment.BACKEND_URL}Questionnaire/${questionnaireId}`)
      .pipe(tap(() => this.clearQuestionnaireCaches()));
  }

  getQuestionnaireDetail(
    questionnaireId: string | number,
  ): Observable<QuestionnaireHistoryItem | null> {
    return this.http
      .get<any>(
        `${environment.BACKEND_URL}Questionnaire/detail/${questionnaireId}`,
      )
      .pipe(map((response) => this.normalizeDetailResponse(response)));
  }

  private mapCurrentQuestionnaire(
    response: any,
  ): IQuestionnaireDetailed | null {
    const payload = response?.data ?? response;

    if (!payload) {
      return null;
    }

    const questionnaire = payload.questionnaire ?? null;
    const answers = payload.answers ?? undefined;
    const createdAt =
      payload.createdDateUtc ??
      payload.creationDate ??
      payload.createdDate ??
      null;
    const updatedAt =
      payload.updatedDateUtc ??
      payload.lastUpdateDate ??
      payload.updatedDate ??
      null;

    return {
      id: Number(payload.questionnaireId ?? payload.id ?? 0),
      questionnaireTemplateId:
        Number(payload.questionnaireTemplateId ?? 0) || 0,
      answerId: payload.answerId ? Number(payload.answerId) : undefined,
      questSubmissionId: payload.questSubmissionId
        ? Number(payload.questSubmissionId)
        : undefined,
      patientId: payload.patientId ? Number(payload.patientId) : undefined,
      visitId: payload.visitId ? Number(payload.visitId) : undefined,
      episodeCareId: payload.episodeCareId
        ? Number(payload.episodeCareId)
        : undefined,
      creationDate: createdAt ?? undefined,
      lastUpdateDate: updatedAt ?? undefined,
      questionnaire,
      answers,
      isSubmitted: !!payload.isSubmitted,
      exists: payload.exists,
      status: payload.status,
      mode: payload.mode,
      canEdit: payload.canEdit,
      submittedBy: this.normalizeActor(payload.submittedBy),
      createdBy: this.normalizeActor(payload.createdBy),
      score: this.toNullableNumber(payload.score),
      scoreLabel: payload.scoreLabel ?? null,
      scoreSeverity: payload.scoreSeverity ?? null,
      scoreRanges: this.normalizeScoreRanges(payload.scoreRanges),
    };
  }

  private normalizeHistoryItem(item: any): QuestionnaireHistoryItem {
    const submission =
      item?.submission ??
      item?.questionnaireSubmission ??
      item?.snapshot ??
      null;
    const answers =
      item?.answers ??
      submission?.answers ??
      submission?.questionnaireSubmissionAnswers ??
      null;
    const answerSource =
      answers && typeof answers === 'object'
        ? (answers as Record<string, any>)
        : null;
    const createdAt =
      item?.createdDate ??
      item?.creationDate ??
      item?.submissionCreatedDateUtc ??
      submission?.createdDateUtc ??
      submission?.createdDate ??
      answerSource?.['createdDateUtc'] ??
      answerSource?.['createdDate'];
    const updatedAt =
      item?.lastUpdateDate ??
      item?.updatedDate ??
      item?.submissionUpdatedDateUtc ??
      submission?.updatedDateUtc ??
      submission?.updatedDate ??
      answerSource?.['updatedTimeUtc'] ??
      answerSource?.['updatedDateUtc'] ??
      answerSource?.['updatedDate'];
    const actorId =
      item?.submittedBy?.userId ??
      item?.createdBy?.userId ??
      item?.submittedBy ??
      item?.createdBy ??
      answerSource?.['userId'] ??
      answerSource?.['createdByUserId'] ??
      answerSource?.['submittedByUserId'];

    return {
      id: item?.id,
      questionnaireId: item?.questionnaireId ?? item?.id,
      questionnaireTemplateId:
        item?.questionnaireTemplateId ?? item?.templateId,
      questSubmissionId:
        item?.questSubmissionId ??
        item?.questionSubmissionId ??
        item?.submissionId ??
        submission?.id,
      answerId: item?.answerId,
      patientId: item?.patientId,
      visitId: item?.visitId ?? submission?.visitId ?? submission?.visit?.id,
      episodeCareId:
        item?.episodeCareId ??
        item?.episodeOfCareId ??
        submission?.episodeCareId ??
        submission?.episodeOfCareId ??
        submission?.episodeCare?.id,
      status: item?.status,
      createdDate: createdAt,
      creationDate: item?.creationDate ?? createdAt,
      lastUpdateDate: updatedAt,
      submittedDate:
        item?.submittedDateUtc ??
        item?.submittedDate ??
        item?.submissionUpdatedDateUtc ??
        updatedAt,
      submittedBy: this.normalizeActor(item?.submittedBy) ?? actorId,
      submittedByName:
        item?.submittedBy?.displayName ??
        item?.submittedByName ??
        item?.submittedByUserName,
      submittedByUserName:
        item?.submittedBy?.username ??
        item?.submittedByUserName ??
        item?.submittedByName,
      createdBy: this.normalizeActor(item?.createdBy) ?? actorId,
      createdByName:
        item?.createdBy?.displayName ??
        item?.createdByName ??
        item?.createdByUserName,
      createdByUserName:
        item?.createdBy?.username ??
        item?.createdByUserName ??
        item?.createdByName,
      visitLabel:
        item?.visitLabel ??
        submission?.visitLabel ??
        submission?.visit?.label ??
        submission?.visit?.visitDate,
      episodeCareLabel:
        item?.episodeCareLabel ??
        item?.episodeOfCareLabel ??
        submission?.episodeCareLabel ??
        submission?.episodeCare?.id,
      isSubmitted: item?.isSubmitted,
      canView: item?.canView,
      canEdit: item?.canEdit,
      isLatestDraftForVisit: item?.isLatestDraftForVisit,
      isLatestSubmission: item?.isLatestSubmission,
      title: item?.title ?? item?.questionnaire?.title,
      score: this.toNullableNumber(item?.score),
      scoreLabel: item?.scoreLabel ?? null,
      scoreSeverity: item?.scoreSeverity ?? null,
      scoreRanges: this.normalizeScoreRanges(item?.scoreRanges),
      submission,
      answersJson: item?.answersJson ?? submission?.answersJson ?? null,
      questionnaireSubmissionAnswers:
        item?.questionnaireSubmissionAnswers ??
        submission?.questionnaireSubmissionAnswers ??
        null,
      questionnaire:
        item?.questionnaire ??
        submission?.questionnaire ??
        item?.template ??
        null,
      answers,
      questionnaireData:
        item?.questionnaireData ?? submission?.questionnaireData ?? null,
    };
  }

  private normalizeDetailResponse(
    response: any,
  ): QuestionnaireHistoryItem | null {
    const payload = response?.data ?? response;

    if (!payload) {
      return null;
    }

    return this.normalizeHistoryItem({
      ...payload,
      id: payload.id ?? payload.questionnaireId,
      questionnaireId: payload.questionnaireId ?? payload.id,
      title: payload.title ?? payload.questionnaire?.title,
      createdDate: payload.createdDateUtc ?? payload.creationDate,
      creationDate: payload.createdDateUtc ?? payload.creationDate,
      lastUpdateDate: payload.updatedDateUtc ?? payload.lastUpdateDate,
      submittedDate: payload.submittedDateUtc ?? payload.updatedDateUtc,
    });
  }

  private normalizeOverviewResponse(
    response: any,
  ): QuestionnaireOverviewResponse {
    const payload = response?.data ?? response;
    const sourceTemplates = Array.isArray(payload?.templates)
      ? payload.templates
      : [];

    return {
      templates: sourceTemplates.map((template: any) =>
        this.normalizeOverviewTemplate(template),
      ),
    };
  }

  private normalizeOverviewTemplate(
    template: any,
  ): QuestionnaireOverviewTemplate {
    const templateTitle = template?.title ?? '';

    return {
      questionnaireTemplateId: Number(template?.questionnaireTemplateId ?? 0),
      title: templateTitle,
      routeSection: template?.routeSection,
      items: Array.isArray(template?.items)
        ? template.items.map((item: any) =>
            this.normalizeOverviewItem(item, templateTitle),
          )
        : [],
    };
  }

  private normalizeOverviewItem(
    item: any,
    templateTitle?: string,
  ): QuestionnaireHistoryItem {
    return {
      id: item?.questionnaireId ?? item?.id,
      questionnaireId: item?.questionnaireId ?? item?.id,
      questionnaireTemplateId: item?.questionnaireTemplateId,
      questSubmissionId: item?.questSubmissionId,
      answerId: item?.answerId,
      patientId: item?.patientId,
      visitId: item?.visitId,
      episodeCareId: item?.episodeCareId,
      createdDate: item?.createdDateUtc ?? null,
      creationDate: item?.createdDateUtc ?? null,
      lastUpdateDate: item?.updatedDateUtc ?? null,
      submittedDate: item?.submittedDateUtc ?? item?.updatedDateUtc ?? null,
      submittedBy: this.normalizeActor(item?.submittedBy),
      visitLabel: item?.visitLabel,
      episodeCareLabel: item?.episodeCareLabel,
      isSubmitted: item?.isSubmitted,
      canView: item?.canView,
      canEdit: item?.canEdit,
      title: item?.title ?? templateTitle,
      score: this.toNullableNumber(item?.score),
      scoreLabel: item?.scoreLabel ?? null,
      scoreSeverity: item?.scoreSeverity ?? null,
      scoreRanges: this.normalizeScoreRanges(item?.scoreRanges),
    };
  }

  private getQuestionnaireOverviewCacheKey(
    patientId: string,
    options: QuestionnaireOverviewQueryOptions,
  ): string {
    return JSON.stringify({
      patientId,
      templateIds: options.templateIds ?? [],
      visitId: options.visitId ?? null,
      episodeCareId: options.episodeCareId ?? null,
      includeDrafts: options.includeDrafts ?? null,
      section: options.section ?? null,
    });
  }

  private clearQuestionnaireCaches(): void {
    this.questionnaireOverviewCache.clear();
  }

  private getBlankQuestionnaire(
    questionnaireTemplateId: number,
  ): Observable<IQuestionnaireDetailed> {
    return this.http
      .get<any>(
        `${environment.BACKEND_URL}Questionnaire/QuestGenie/${questionnaireTemplateId}`,
      )
      .pipe(
        map((response: any) => {
          const questionnaire = this.extractQuestionnaireTemplate(response);

          return {
            id: 0,
            questionnaireTemplateId,
            patientId:
              Number(this.patientService.patientIDsignal()) || undefined,
            visitId: Number(this.eocService.currentVisitId()) || undefined,
            episodeCareId: Number(this.eocService.currentEocId()) || undefined,
            questionnaire,
            answers: undefined,
            isSubmitted: false,
          } as IQuestionnaireDetailed;
        }),
      );
  }

  private extractQuestionnaireItems(response: any): IQuestionnaireDetailed[] {
    if (Array.isArray(response?.data)) {
      return response.data;
    }

    if (Array.isArray(response)) {
      return response;
    }

    return [];
  }

  private extractQuestionnaireTemplate(
    response: any,
  ): IQuestionnaire | undefined {
    return (
      response?.data?.questionnaire ?? response?.data ?? response ?? undefined
    );
  }

  private normalizeActor(actor: any): IQuestionnaireActor | null {
    if (!actor) {
      return null;
    }

    if (typeof actor === 'string') {
      return {
        userId: actor,
      };
    }

    return {
      userId: actor.userId ?? actor.id ?? undefined,
      displayName: actor.displayName ?? actor.fullName ?? undefined,
      username: actor.username ?? null,
    };
  }

  private normalizeScoreRanges(ranges: any): IQuestionnaireScoreRange[] | null {
    if (!Array.isArray(ranges)) {
      return null;
    }

    return ranges
      .map((range: any) => ({
        min: Number(range.min ?? 0),
        max:
          range.max === null || range.max === undefined
            ? null
            : Number(range.max),
        label: String(range.label ?? ''),
        severity: range.severity,
      }))
      .filter((range: IQuestionnaireScoreRange) => Number.isFinite(range.min));
  }

  private toNullableNumber(value: unknown): number | null {
    if (
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '')
    ) {
      return null;
    }

    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : null;
  }

  private resolveVisitId(): number | null {
    const visitId = this.eocService.currentVisitId();
    return visitId ? Number(visitId) : null;
  }
}
